import { render, staticRenderFns } from "./openstreemap2.vue?vue&type=template&id=c9621fba&"
import script from "./openstreemap2.vue?vue&type=script&lang=js&"
export * from "./openstreemap2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9621fba')) {
      api.createRecord('c9621fba', component.options)
    } else {
      api.reload('c9621fba', component.options)
    }
    module.hot.accept("./openstreemap2.vue?vue&type=template&id=c9621fba&", function () {
      api.rerender('c9621fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/openstreemap2.vue"
export default component.exports